module.exports = __webpack_public_path__ + "img/co-workers.99aa59f4.svg";